import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

// Caja gris con un icono que "simula" la foto de un producto, mientras el catalogo todavia
// no tiene imagenes reales cargadas (ver ProductCard, ProductDetailPage y el admin de productos).
export default function ProductImagePlaceholder({ height, iconFontSize }) {
  return (
    <Box
      sx={{
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'action.hover',
        color: 'text.disabled',
      }}
    >
      <ImageOutlinedIcon sx={{ fontSize: iconFontSize }} />
    </Box>
  );
}

ProductImagePlaceholder.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconFontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ProductImagePlaceholder.defaultProps = {
  height: 160,
  iconFontSize: 40,
};
